<template>
  <div
    class="category"
    :class="[checked && 'category--checked']"
    @click="$emit('click',{'id':$event.target.id})"
  >
    <slot />
    <v-icon
      class="category__icon"
      type="check"
    />
  </div>
</template>

<script>
  import Icon from "@/atoms/Icon";
  import IconCheckbox from "@/atoms/IconCheckbox";

  export default {
    components: {
      "v-icon": Icon
    },
    props: {
      checked: {
        type: Boolean,
        default: false,
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .category {
    $this: &;
    position: relative;
    padding: $card-padding-y ($card-padding-x + 2rem) $card-padding-y $card-padding-x;
    border-bottom: solid 1px $zircon;
    cursor: pointer;
    transition: .15s;
    &__icon {
      position: absolute;
      top: 50%;
      right: $card-padding-x;
      margin-right: .5rem;
      margin-top: -(($font-size-base * $line-height-base) / 2);
      color: $white;
      transform: scale(0);
    }
    &:hover {
      background-color: $zircon;
    }
    &--checked {
      #{$this}__icon {
        transform: scale(1);
      }
      &,
      &:hover {
        border-bottom-color: $azure;
        background-color: $azure;
        color: $white;
        cursor: default;
      }
    }
  }
</style>
